import React, { useEffect, useState } from "react";
import Loader from "../../../common/Loader";
import { getLabel } from "../../../data/labels";
import { useFetchSystemBetDetails } from "../../fetchSystemBetDetails";
import { getConfiguration, getHiddenTicket, getQueryStringVariable } from "../../utils";
import SystemBetsNTupleGroup from "./SystemBetsNTupleGroup";
import './CheckSystemBets.css';


function CheckSystemBets(props) {
    const conf = getConfiguration();
    const [data, setData] = useState(null);
    const [showLoader, setShowLoader] = useState(true);
    const ticketId =  getQueryStringVariable('ticketId') || getQueryStringVariable('ticket') || props.ticketId;
    const [state] = useFetchSystemBetDetails(ticketId);

    useEffect(() => {
        if (!state.isLoading && !state.isError) {
            setData(state.data);
            setShowLoader(false);
        }
    }, [state.data, state.isError, state.isLoading]);

    return (
        <> 
         {showLoader ?
            <Loader error={state.isError} />
            :    
            <>
            <div className="containerCheckSystemBets" >
                <div className="titleContainerCheckSystemBets" >
                        <h2>{getLabel('check_system_bets.title')}</h2>
                        <h6>{getLabel('control_panel.print_tickets.search_results.header.ticket_id')+": "+(props.obfuscateTicketId?getHiddenTicket(ticketId):ticketId)}</h6>
                </div>
                {data && data.tuplesGroups?.map((NTupleGroup,index)=>{
                    return(NTupleGroup && 
                        <React.Fragment  key={index}>
                            <SystemBetsNTupleGroup key={index}  NTupleGroup={NTupleGroup} index={index} /> 
                            <br/><br/>
                        </React.Fragment>
                    ) 
                })

                }
                
            </div>
            </>
        }
        </>
    )
}

export default CheckSystemBets;